export default __webpack_public_path__ + "static/media/ischool_kku.43d067b0.png";